import axios from 'axios';

/**
 * Service passed to DB that fetches form configs from the
 * /api/forms/config/:providerId endpoint
 *
 * @param {String} providerId the provider ID
 * @returns Promise<Object> the resulting form config (axios.get().data)
 */
export const getPatientRegForm = async (providerId) => {
  const res = await axios.get(`/api/forms/config/${providerId}`);
  return res.data;
};
